import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
// import { Link } from 'react-router-dom';
import styled from "styled-components";
import emailcone from "./envelope-regular.svg";
import phoneIcon from "./phone-alt-solid.svg";


export const Link = styled.a`
  text-decoration: none;
  color: #000000;
  cursor: pointer;
  transition: all 0.5s ease;
  margin: 8px 0;
  &:hover {
    color: #000000;
    font-weight: 400;
  }
`;

export const Icon = styled.div`
  width: 15px;
  displey: inline-block;
  display: grid;
  place-items: center;
  margin-right: 8px;
`;
export const List = styled.ul`
  list-style: none;
  padding: 0;
`;
export const ListItem = styled.li`
  list-style: none;
  display: flex;
  aling-items: center;
`;
const Hours = styled(Link)`
  &:hover:before {
    color: #006400;
  }
  &:before {
    content: ">";
    color: #006400;
  }
`;
const Span = styled.span`
  color: #006400;
`;

const Footer = () => {
  return (
    <footer>
      <Container>
        <Row>
          <Col className="text-center py-3">Copyright &copy; Irio Hub</Col>
        </Row>
        <address>
            <List>
              <ListItem>
                <Icon>
                  <img src={phoneIcon} alt="phone"></img>
                </Icon>{" "}
                <Link href="tel://254791801791">254 791801791</Link>
              </ListItem>
              <ListItem>
                <Icon>
                  <img src={emailcone} alt="email"></img>
                </Icon>{" "}
                <Link href="mailto:iriohubb@gmail.com">
                  iriohubb@gmail.com
                </Link>
              </ListItem>
            </List>
          </address>
          <h4>OPENING HOURS</h4>
          <List>
            <ListItem>
              <Hours> Mondays - Saturdays --------- 9:30am - 8:45pm</Hours>
            </ListItem>
            <ListItem>
              <Hours>
                {" "}
                Sundays --------- <Span>Closed</Span>
              </Hours>
            </ListItem>
          </List>
      </Container>
    </footer>
  );
};

export default Footer;
